module.exports = __webpack_public_path__ + "img/NatGas_80X30.e2b0fe2d.png";